import { Component, HostListener } from '@angular/core';

import { Platform, NavController, MenuController, LoadingController, AlertController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { environment } from '../environments/environment';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { CommonService } from './common/common.service';
import { UserService } from './common/user.service';
import { LandingSliderPage } from './pages/landing-slider/landing-slider.page';
import { filter } from 'rxjs/operators';
import { map, tap, takeUntil} from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Zoom } from '@ionic-native/zoom/ngx';


// declare let $;
// $.connection.hub.url = environment.HubUrl;
// const chat = $.connection.chatHub;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  instLogo: string;
  user: any = null;
  permission: any = {
    product_management: false
  };
  rootPage: any = LandingSliderPage;
  studentInfo = [];
  studentImage: any;
  studentName: any;
  DownloadImage = environment.DownloadImage;
  Capture: string;
  menuItems: any;
  menuItemsAfterLogin: any;
  cartItems = [];
  webDashboard: boolean;
  appversion: string;
  appversionRequired: string;
  link: string;
  menuForEdusomeApp: any;
  menuForOtheApp: any;
  app = environment.AppName;
  isLoggedIn: boolean;
  loginType: string;

  pages: any = [
    { title: 'Home', component: 'home' },
    { title: 'My Profile', component: 'profile' },
    /* { title: 'Feedback', component: 'notifications' }, */
  ];
  appName: string;

  ismobile: boolean;
  instituteLogo: any;
  aboutInstituteData: any = {};

  menuListBeforeLogin = [
    {
      'title': 'About Us',
      'icon': 'person',
      'route': 'about-institute'
    },
    {
      'title': 'Admission',
      'icon': 'school',
      'route': 'branches'
    },
    {
      'title': 'Awards & Achievements',
      'icon': 'megaphone',
      'route': 'awards-achievements'
    },
    {
      'title': 'Our Message',
      'icon': 'chatbubble-ellipses',
      'route': 'chairman-message'
    },/* 
    {
      'title': 'Our Team',
      'icon': 'people',
      'route': ''
    }, */
    {
      'title': 'Book a demo',
      'icon': 'calendar-number',
      'route': 'book-demo'
    },
    {
      'title': 'Enquiry',
      'icon': 'help-circle',
      'route': 'enquiry'
    },
    {
      'title': 'Map',
      'icon': 'map',
      'route': 'map'
    },
    {
      'title': 'About Developer',
      'icon': 'people-circle',
      'route': 'about-developer'
    },
  ];

  menuListAfterLogin = [
    {
      'title': 'Monthly Calendar ',
      'icon': 'calendar',
      'route': 'monthly-calendar'
    },
    {
      'title': 'Quiz',
      'icon': 'create',
      'route': 'test-paper'
    },
    {
      'title': 'Online Class',
      'icon': 'videocam',
      'route': 'online-class'
    },
    {
      'title': 'Timetable',
      'icon': 'calendar',
      'route': 'timetable'
    },
    {
      'title': 'Attendance',
      'icon': 'today',
      'route': 'attendance'
    },
    {
      'title': 'Announcement',
      'icon': 'megaphone',
      'route': 'announcement'
    },
    {
      'title': 'Messages',
      'icon': 'chatbubble',
      'route': 'notifications'
    },
    {
      'title': 'Media',
      'icon': 'videocam',
      'route': 'media'
    },
    {
      'title': 'Study Material',
      'icon': 'book',
      'route': 'study-material'
    },
    {
      'title': 'Fees Payment',
      'icon': 'wallet',
      'route': 'fee-payments'
    },
    {
      'title': 'Feedback',
      'icon': 'open',
      'route': 'feedback'
    }
    
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public navCtrl: NavController,
    private menu: MenuController,
    private userService: UserService,
    private commonService: CommonService,
    private loadingCtrl: LoadingController,
    private router: Router,
    private zoomService: Zoom,
    public alertCtrl: AlertController,
    private iab: InAppBrowser,
  ) {

    this.user = JSON.parse(localStorage.getItem('currentUser'));

    this.initializeApp();

    this.commonService.loginType.subscribe(loginType => {
      this.loginType = loginType;
    });

    this.userService.studentImage.subscribe(studentImage => {
      this.studentImage = studentImage;
    });

    this.userService.studentName.subscribe(studentName => {
      this.studentName = studentName;
    });

    this.userService.isLoggedIn.subscribe(isLoggedIn => {
      this.isLoggedIn = isLoggedIn;
    });

    this.appName = environment.ClientAppName;
    console.log(this.isLoggedIn)

  }



  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.backgroundColorByName('white');
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      document.body.setAttribute('data-theme', 'light');
      document.body.classList.toggle('dark', false);
      this.aboutInstitute();
      this.GetInstitutePermissions();
      this.getInstituteSocialShare();
      this.zoomInit();
      
    });
  }

 

  zoomInit() {
    const API_KEY = 'CT0CFsymZFDrfi2gY7XKgTbiUJZZk53uk1V0';
    const API_SECRET = 'GgQxB203pKzmEgMkCqHHNDJ9iea3QSPdPP3E'; 
    //const API_KEY = 'BJ0uFZnDRFqfx_ldEV95rQ';
    //const API_SECRET = 'uSI4AtUayhVzitCvbQKc6J7nwJNHGFDxkokB';
    // const API_KEY = 'XjrFz6JNQ--y5ZxkIVxBmQ';
    // const API_SECRET = 'Av7a4xTyv7dYFswd3uHFlLpIlGqzuGg0haoJ';
    console.log(this.zoomService)

    this.zoomService.initialize(API_KEY, API_SECRET)
      .then((success) => {
        console.log(success)
      })
      .catch((error) => {
        console.log(error)

      });
  }

  async checkUpdateInApp() {
    let alert = await this.alertCtrl.create({
      header: 'You are using an older version of the app!',
      message: 'Update your app from the playstore and get new features!',
      buttons: [
        {
          text: 'Update Now',
          role: 'cancel',
          cssClass: 'darkgray',
          handler: () => {
            let url = this.link;
            window.open(url, '_system');
          }
        }
      ],
      backdropDismiss: false
    });
    alert.present();
  }

  getInstituteSocialShare() {
    this.commonService.getInstituteSocialShare().subscribe((resp) => {
      if (this.platform.is('android')) {
        this.link = resp.Item.app_playstore_url;
      }
      else {
        this.link = resp.Item.app_appstore_url;
      }


    });
  }


  openPage(p) {
    this.menu.close();
    this.navCtrl.navigateForward('/' + p.component);
  }

  closed$ = new Subject<any>();
  showTabs = true; 

  ngOnInit() {
    if (this.user != null) {
      this.userService.isLoggedIn.next(true);

      const loginType = localStorage.getItem('loginType');
      console.log(loginType)

      if(loginType === 'Admin'){
        this.navCtrl.navigateRoot('/home-admin');
        return false;
      }
      else if(loginType === 'Faculty'){
        this.navCtrl.navigateRoot('/home-faculty');
        return false;
      }
      else if(loginType === 'Demo'){
        this.navCtrl.navigateRoot('/home-demo');
      }
      else if(loginType === 'Student'){
        this.navCtrl.navigateRoot('/home');
      }
      else if(loginType === 'Recorded'){
        this.navCtrl.navigateRoot('/recorded-home');
      }
      else{
        this.navCtrl.navigateRoot('/login');
      }
      

      console.log(loginType);


    } else if (this.user == null) {

      localStorage.removeItem('currentUser');
      this.navCtrl.navigateForward('');

    }

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntil(this.closed$)
    ).subscribe(event => {
      console.log(event['url'])
      if (event['url'] === '/landing-slider' || event['url'] === '/games' || event['url'] === '/') {
        this.showTabs = false; // <-- hide tabs on specific pages
      }
      else{
        this.showTabs = true;
      }
    });

  }

  onLogout() {
    this.removeToken();
  }

  async removeToken() {
    this.menu.close();

    const loading = await this.loadingCtrl.create({
      message: 'Logging out...',
    });
    await loading.present();

    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.userService.removeToken(this.user.student_id).subscribe((result) => {
      localStorage.removeItem('currentUser');
      localStorage.removeItem('myprofile');
      localStorage.removeItem('loginType');
      localStorage.removeItem('subject_id');
      this.userService.studentName.next(null);
      this.userService.studentImage.next(null);

      this.user = null;
      this.userService.isLoggedIn.next(false);
      loading.dismiss();
      this.navCtrl.navigateRoot('/login');
    });
  }

  gotoMyprofile() {
    this.menu.close();
    this.navCtrl.navigateForward('/profile');
  }

  getStudentProfile() {
    this.userService.getStudentProfile(this.user.student_id).subscribe((resp) => {
      this.studentInfo = resp.Item;
      this.userService.studentName.next(resp.Item.name);
      if (resp.Item.picture == null) {
        this.userService.studentImage.next('https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.shareicon.net%2Fdata%2F2016%2F05%2F24%2F770117_people_512x512.png&f=1&nofb=1');
      }
      else {
        this.userService.studentImage.next(this.DownloadImage + '' + resp.Item.picture);
      }
    });
  }

  GetInstitutePermissions() {
    this.commonService.GetInstitutePermissions().subscribe((resp) => {
      this.permission = resp.Item;
    });
  }

  public getCartItemAndValue() {
    let item: any = {
      quantity: 0,
      price: 0
    };
    let cartitem = JSON.parse(localStorage.getItem('cartValue'));
    if (cartitem != null) {
      for (let citem of cartitem) {
        item['quantity'] = item['quantity'] + citem.quantity;
        item['price'] = item['price'] + (citem.price * citem.quantity);
      }
    }
    return item;
  }

  public getCartItemAndValueAdm() {
    let item: any = {
      quantity: 0,
      price: 0
    };
    let cartitem = JSON.parse(localStorage.getItem('cartValueAdm'));
    if (cartitem != null) {
      for (let citem of cartitem) {
        item['quantity'] = item['quantity'] + citem.quantity;
        item['price'] = item['price'] + (citem.price * citem.quantity);
      }
    }
    return item;
  }





  aboutInstitute() {
    console.log(this.instLogo);
    this.commonService.getNonSecureAboutInstitute().subscribe(result => {
      this.aboutInstituteData = result.Item;
      console.log(this.aboutInstituteData);
      this.instLogo = this.DownloadImage + '' + result.Item.image;
      console.log(this.instLogo);
    });
  }

  redirectTo(route: string){
    this.menu.close();
    this.navCtrl.navigateForward(route);
  }

}
